import React, { useEffect, useState, } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import axios from "axios";
import { useGlobalContext } from '../GlobalContext';
import GantiPasswordModal from './GantiPasswordModal';

const Menu = () => {
  const { api, koderole, nama, periode, periodeakun, clearUserData, menuakses } = useGlobalContext();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(null);
  const [showGantiPasswordModal, setShowGantiPasswordModal] = useState(false);

  const toggleMenu = (menuName) => {
    setOpenMenu(prev => prev === menuName ? null : menuName);
  };

  const normalizeMenuUrl = (url) => {
    if (!url) return '#';

    const cleanUrl = String(url).trim();
    if (!cleanUrl || cleanUrl === '#') return '#';

    const path = cleanUrl.startsWith('/') ? cleanUrl : `/${cleanUrl}`;
    const routeAliases = {
      '/daftarsimpharian': '/daftarsimpmanasuka',
      '/daftarsimpsaham': '/daftarsimpsaham',
    };

    return routeAliases[path.toLowerCase()] || path;
  };

   const groupedMenu = (menuakses || []).reduce((acc, item) => {
    if (!acc[item.menu]) {
      acc[item.menu] = [];
    }
    acc[item.menu].push(item);
    return acc;
  },{});

  const groupedMenuArray = Object.keys(groupedMenu).map(menu => ({
    menu,
    icon: groupedMenu[menu][0]?.icon || "fas fa-folder",
    items: groupedMenu[menu] 
  }));

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      /*const dataUser = localStorage.getItem("pengguna");
      if (dataUser) {
        const parsed = JSON.parse(dataUser);
        if (parsed.token) {
          await api.post('/users/logout', { "kode": parsed.kode });
        }
      }*/
      await api.post('/users/logout');
    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      clearUserData();
      navigate('/login', { replace: true });
    }
  };

  const handleGantiPassword = (e) => {
    e.preventDefault();
    setShowGantiPasswordModal(true);
  };

  // Format periode
  const formatPeriode = (periodeCode) => {
    if (!periodeCode) return '-';
    const year = periodeCode.substring(0, 4);
    const month = periodeCode.substring(4, 6);
    const months = ['', 'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 
                    'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
    return `${months[parseInt(month)]} ${year}`;
  };

  return (
    <>
      <aside className="main-sidebar sidebar-dark-primary elevation-4"
        style={{
          height: "100vh",
          overflowY: "auto",
          position: "fixed",
          top: 0,
          left: 0,
        }}
      >
        <a href="#" className="brand-link">
          <img src="logo_koperasi.jpg" alt="AdminLTE Logo" className="brand-image img-circle elevation-3" />
          <span className="brand-text font-weight-light">SI-KOPi</span>
        </a>

        <div className="sidebar">
          <div className="user-panel mt-2 pb-2 mb-2">
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
              <div className="image" style={{ marginTop: '10px' }}>
              <img src="dist/img/profil.jpg" className="img-circle elevation-2" alt="User" />
              </div>
              <div className="info">
                <a 
                  href="/" 
                  className="d-block" 
                  onClick={handleGantiPassword}
                  style={{ cursor: 'pointer', textDecoration: 'none' }}
                >
                  {nama || 'Nama Pengguna'}
                </a>
              </div>
            </div>
            <div style={{ paddingLeft: '8px', paddingRight: '8px', borderTop: '1px solid rgba(255,255,255,0.2)', paddingTop: '8px' }}>
              <span className="d-block text-light">Periode USP : {formatPeriode(periode)}</span>
              <span className="d-block text-light">Periode AKUN : {formatPeriode(periodeakun)}</span>
            </div>
          </div>

          <div className="form-inline">
            <div className="input-group" data-widget="sidebar-search">
              <input className="form-control form-control-sidebar" type="search" placeholder="Search" aria-label="Search" />
              <div className="input-group-append">
                <button className="btn btn-sidebar">
                  <i className="fas fa-search fa-fw" />
                </button>
              </div>
            </div>
          </div>

          <nav className="mt-2">          
            <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="true">
              {/* Dashboard */}
              <li className={`nav-item has-treeview ${openMenu === 'Dashboard' ? 'menu-open' : ''}`}>
                <a
                  href="#"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu('Dashboard');
                  }}
                >
                  <i className="nav-icon fas fa-tachometer-alt"></i>
                  <p>
                    Dashboard
                    <i className="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul
                  className="nav nav-treeview"
                  style={{ display: openMenu === 'Dashboard' ? 'block' : 'none' }}
                >
                  <li className="nav-item">
                    <NavLink to="/dashboard/piutang" className="nav-link">
                      <i className="far fa-circle nav-icon"></i>
                      <p>Piutang</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/dashboard/simpanan" className="nav-link">
                      <i className="far fa-circle nav-icon"></i>
                      <p>Simpanan</p>
                    </NavLink>
                  </li>
                </ul>
              </li>

              {groupedMenuArray.map(({menu, icon, items}) => (        
                <li className={`nav-item has-treeview ${openMenu === menu ? 'menu-open' : ''}`} key={menu}>
                  <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); toggleMenu(menu); }}>
                    <i className={`nav-icon ${icon}`}></i>
                    <p>
                      {menu}
                      <i className="right fas fa-angle-left"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview" style={{ display: openMenu === menu ? 'block' : 'none' }}>
                    {items.map((item) => (
                      <li className="nav-item" key={item.kode_hal}>
                        <NavLink to={normalizeMenuUrl(item.url)} className="nav-link">
                          <i className={item.icons}></i>
                          <p>{item.halaman}</p>
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </li>             
              ))}                      

              {/* Logout */}
              <li className="nav-item">
                <a href="#" className="nav-link" onClick={handleLogout}>
                  <i className="nav-icon fa fa-sign-out-alt"></i>
                  <p>Logout</p>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </aside>

      {/* Ganti Password */}
      <GantiPasswordModal 
        isOpen={showGantiPasswordModal}
        onClose={() => setShowGantiPasswordModal(false)}
        userName={nama}
        api={api}
      />
    </>
  );
}

export default Menu;